const header = document.querySelector('.header-wrapper');
const headerHome = document.querySelector('.index .header-wrapper');
const announcementBar2 = document.querySelector('#shopify-section-announcement-bar');

console.log(header);
console.log(headerHome);
if (headerHome !== null) {
  console.log('is home');
  window.onscroll = () => {
      if (window.scrollY > 120) {
        if (header.classList.contains('header-position-static')){
            header.classList.remove('header-position-static')
            header.classList.add('header-position-fixed')
            document.getElementById('MainContent').classList.add('is-fixed')
            announcementBar2.querySelector('.sticky').classList.add('is-fixed');
        }
      } else {
        if (header.classList.contains('header-position-fixed')){
           header.classList.add('header-position-static')
           header.classList.remove('header-position-fixed') 
           document.getElementById('MainContent').classList.remove('is-fixed')
           announcementBar2.querySelector('.sticky').classList.remove('is-fixed');
        }

      }
  };
} else {
  if (header.classList.contains('header-position-static')) {
    header.classList.remove('header-position-static');
    header.classList.add('header-position-fixed');
  }
}

const searchBtn = document.querySelector('details-modal>details');
const mainContent = document.querySelector('#MainContent');
const searchModal = document.querySelector('.search-modal');

// searchBtn.parentElement.addEventListener("click", () => {
//   announcementBar2.style.zIndex = '9';
//   if(window.scrollY > 250){
//     header.style.marginTop = '-10.5rem';
//     searchModal.style.borderBottom = '2px solid #f0bb5a';
//   };
// });

document.addEventListener('mouseup', function(e) {
    if (!header.firstChild.contains(e.target) && !announcementBar2.contains(e.target)) {
      announcementBar2.style.zIndex = '10';      
    };
});





// let searchBar = (function() {
//   const searchBtn = document.querySelector('details-modal>details');
//   const mainContent = document.querySelector('#MainContent');
//   const searchModal = document.querySelector('.search-modal');
//   function open(){
//     searchBtn.parentElement.addEventListener("click", () => {
//       announcementBar2.style.zIndex = '9';

//       if(window.scrollY > 250){
//         header.style.marginTop = '-10.5rem';
//         searchModal.style.borderBottom = '2px solid #f0bb5a';
//       };

//       window.onscroll((e) => {
//         if(announcementBar2.style.zIndex === '9'){
//           announcementBar2.style.zIndex === '10';
//           header.style.marginTop = '-6.5rem';
//           searchModal.style.borderBottom = 'none';
//         }
//       })
      
//     });
//   }
//   return { open:open }
// }) ();

class MenuDrawerNavLink extends HTMLElement {
  constructor() {
    super();

    this.buttonLinks = document.querySelector('.button-like-nav-links-container');
    this.newsletter = document.querySelector('.menu-drawer-newsletter');
    this.allNavLinks = document.querySelectorAll('.menu-drawer__navigation .menu-drawer__menu-item');
    this.search = document.querySelector('.menu-drawer-search-bar');
    
    this.arrow = this.querySelector('.menu-drawer__menu-item svg');
    this.navLinks = this.querySelectorAll('.menu-drawer__menu-item');
    this.details = this.querySelector('details');
    this.breadcrumbs = this.querySelector('.menu-drawer-breadcrumbs');

    this.toggleHiddenClass = this.toggleHiddenClass.bind(this);
  }

  connectedCallback() {
    this.details.addEventListener('click', this.toggleHiddenClass);
    this.breadcrumbs.addEventListener('click', () => {
      this.toggleHiddenClass();

      if (this.details) {
        this.details.open = !this.details.open;
      }
    });
  }

  disconnectedCallback() {
    this.details.removeEventListener('click', this.toggleHiddenClass);
    this.breadcrumbs.removeEventListener('click', () => {
      this.toggleHiddenClass();

      if (this.details) {
        this.details.open = !this.details.open;
      }
    });
  }

  toggleHiddenClass() {
    this.allNavLinks.forEach(link => {
      link.classList.toggle('hidden');
    });

    this.navLinks.forEach(link => {
      link.classList.toggle('hidden');
    });

    [this.buttonLinks, this.newsletter, this.search, this.breadcrumbs, this.arrow].forEach(el => {
      el.classList.toggle('hidden');
    });
  }
}

customElements.define('menu-drawer-nav-link', MenuDrawerNavLink);
